<template>
  <v-card>
    <ODialogBar title="Resumo da Medição" no-close>
      <v-btn small icon class="ml-16" @click="navigate(-1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="mx-2">{{ strDateRange }}</span>
      <v-btn small icon @click="navigate(+1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer />
    </ODialogBar>
    <OLoadingLine absolute :value="isLoading" />
    <v-card-text>
      <div class="w-full d-flex">
        <div class="measureItem" v-for="item in measureItems" :key="item.label">
          <h1>{{ item.value }}</h1>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import EditStore from './EditStore'
import moment from 'moment'
import { CostCenter } from '@/models'
import fmt from 'oderon-commons/src/formatters'

export default {
  data() {
    let refD = EditStore.row.referenceDay
    let curD = moment().get('date')

    let month = moment().startOf('month')
    if (curD < refD) {
      month = month.add(-1, 'month').startOf('month')
    }

    return {
      isLoading: false,
      month,
      measureItems: []
    }
  },

  computed: {
    dateRange() {
      let refD = EditStore.row.referenceDay
      let fd = moment(this.month).set('date', refD)
      let ud = moment(this.month)
        .add(1, 'month')
        .set('date', refD - 1)
      if (refD == 1) {
        ud = moment(this.month)
          .endOf('month')
          .startOf('day')
      }

      return [fd, ud]
    },

    strDateRange() {
      let fd = moment(this.dateRange[0]).format('DD/MMM/YYYY')
      let ud = moment(this.dateRange[1]).format('DD/MMM/YYYY')
      return `${fd} até ${ud}`
    }
  },

  watch: {
    month() {
      this.reload()
    },
    'EditStore.row'() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },

  methods: {
    navigate(n) {
      this.month = moment(this.month)
        .add(n, 'month')
        .startOf('month')
    },

    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      // await this.$delay(1000)
      let measure = await CostCenter.getMultiproductMeasureTotal({
        costCenterId: EditStore.row.id,
        month: this.month.format('YYYY-MM')
      })

      // this.measureItems = [
      //   { text: 'Valor total', value: 'R$ 1.234,56' },
      //   { text: 'Módulos', value: '12' },
      //   { text: 'Instalações', value: '3' },
      //   { text: 'Retiradas', value: '2' }
      // ]

      let total = measure.total[0]
      let valorServicos =
        total.install.value + total.remove.value + total.intervention.value

      this.measureItems = [
        { text: 'Valor mensalidade', value: fmt.brMoney(total.proRata.value) },
        { text: 'Valor serviços', value: fmt.brMoney(valorServicos) },
        { text: 'Produtos', value: total.proRata.count },
        { text: 'Instalações', value: total.install.count },
        { text: 'Retiradas', value: total.remove.count }
      ]
    }
  }
}
</script>

<style lang="sass">
.measureItem
  flex-basis: 0
  flex-grow: 1
  flex-shrink: 1
  text-align: center
</style>
